import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface DownloadInventoryHistoryCSVRequest {
  token: string;
  apiColumnFilters: any;
  apiSorting: any;
}

const downloadInventoryHistoryCSV = async ({
  token,
  apiColumnFilters,
  apiSorting,
}: DownloadInventoryHistoryCSVRequest) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.WMS)}/wms/inventory/download-inventory-history-csv`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          columnFilters: apiColumnFilters,
          sorting: apiSorting,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default downloadInventoryHistoryCSV;
